export default __webpack_public_path__ + "static/media/facebook-icon.a6d93ed3.svg";